import React from 'react';
import Icon from 'components/AppIcon';

const UserFilters = ({ filters, onFiltersChange }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange({
      role: '',
      status: '',
      dateRange: ''
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Role Filter */}
      <div className="relative">
        <select
          value={filters.role}
          onChange={(e) => handleFilterChange('role', e.target.value)}
          className="
            appearance-none bg-surface border border-secondary-200 rounded-md px-3 py-2 pr-8 text-sm
            focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
            transition-all duration-150
          "
        >
          <option value="">Все роли</option>
          <option value="Администратор">Администратор</option>
          <option value="Менеджер">Менеджер</option>
          <option value="Модератор">Модератор</option>
          <option value="Пользователь">Пользователь</option>
        </select>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-secondary-400 pointer-events-none" 
        />
      </div>

      {/* Status Filter */}
      <div className="relative">
        <select
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          className="
            appearance-none bg-surface border border-secondary-200 rounded-md px-3 py-2 pr-8 text-sm
            focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
            transition-all duration-150
          "
        >
          <option value="">Все статусы</option>
          <option value="active">Активные</option>
          <option value="inactive">Неактивные</option>
          <option value="pending">Ожидающие</option>
          <option value="suspended">Заблокированные</option>
        </select>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-secondary-400 pointer-events-none" 
        />
      </div>

      {/* Date Range Filter */}
      <div className="relative">
        <select
          value={filters.dateRange}
          onChange={(e) => handleFilterChange('dateRange', e.target.value)}
          className="
            appearance-none bg-surface border border-secondary-200 rounded-md px-3 py-2 pr-8 text-sm
            focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
            transition-all duration-150
          "
        >
          <option value="">Все даты</option>
          <option value="week">Последняя неделя</option>
          <option value="month">Последний месяц</option>
          <option value="quarter">Последние 3 месяца</option>
        </select>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-secondary-400 pointer-events-none" 
        />
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={clearFilters}
          className="
            flex items-center gap-2 px-3 py-2 text-sm text-text-secondary
            hover:text-primary transition-colors duration-150
          "
        >
          <Icon name="X" size={16} />
          Очистить
        </button>
      )}

      {/* Advanced Search Toggle */}
      <button className="
        flex items-center gap-2 px-3 py-2 border border-secondary-200 rounded-md text-sm
        hover:bg-secondary-50 transition-colors duration-150
      ">
        <Icon name="Filter" size={16} />
        Расширенный поиск
      </button>
    </div>
  );
};

export default UserFilters;